// t25 - Load More Pagination 기능
(function() {
  'use strict';

  class ImprovedLoadMorePagination {
    constructor() {
      this.init();
    }

    init() {
      this.loadMoreButton = document.querySelector('.js-pagination-load-more');
      this.productList = document.querySelector('.product-list--collection');
      this.productListWrapper = document.querySelector('.js-product-list-wrapper');
      this.paginationElement = document.querySelector('.js-pagination');
      this.isLoading = false;
      this.storageKey = 't25_pagination_loaded_' + window.location.pathname; // Pathname별로 저장

      // 기존 리스너 제거 (중복 방지)
      if (this.loadMoreButton) {
        const newButton = this.loadMoreButton.cloneNode(true);
        this.loadMoreButton.parentNode.replaceChild(newButton, this.loadMoreButton);
        this.loadMoreButton = newButton;
        
        this.loadMoreButton.addEventListener('click', this.handleLoadMoreClick.bind(this));
        
        // 네비게이션 타입 확인 (최초 생성 시에만 실행)
        if (!window.t25PaginationInitialized) {
            const navEntry = performance.getEntriesByType("navigation")[0];
            const navType = navEntry ? navEntry.type : 'navigate'; 
            
            // 'back_forward' (뒤로가기) 인 경우에만 상태 복원
            // 'reload' (새로고침) 또는 일반 진입 시에는 초기화 (사용자 요청 사항)
            if (navType === 'back_forward') {
                setTimeout(() => this.restoreState(), 0);
            } else {
                sessionStorage.removeItem(this.storageKey);
            }
            window.t25PaginationInitialized = true;
        }
      }
    }

    handleLoadMoreClick(event) {
      event.preventDefault();
      event.stopPropagation();
      
      const nextUrl = this.loadMoreButton.getAttribute('data-next-url');
      if (nextUrl) {
        this.loadMore(nextUrl);
      }
    }

    async loadMore(nextUrl, isRestoring = false) {
      if (this.isLoading) return;

      this.isLoading = true;
      this.setLoadingState(true, isRestoring);

      try {
        const url = new URL(nextUrl, window.location.origin);
        const sectionId = this.getSectionId();
        
        if (url.search) {
          url.search += '&section_id=' + sectionId;
        } else {
          url.search = '?section_id=' + sectionId;
        }

        const response = await fetch(url.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (!response.ok) throw new Error('Failed to load');

        const html = await response.text();
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        this.appendProducts(tempDiv);
        this.updatePagination(tempDiv, isRestoring);

        // URL 업데이트 로직 제거
        // 이유: URL을 ?page=2로 변경하면, 뒤로가기 시 브라우저가 2페이지만 렌더링함.
        // URL을 변경하지 않아야 뒤로가기 시 1페이지(서버렌더) + 2페이지(JS복원)가 정상 작동함.
        
        // 상태 저장 (복원 중이 아닐 때만)
        if (!isRestoring) {
            this.saveUrlToState(nextUrl);
        }

      } catch (error) {
        // console.error('Load More Error:', error);
        if (!isRestoring) this.showError();
      } finally {
        this.isLoading = false;
        this.setLoadingState(false, isRestoring);
      }
    }

    getSectionId() {
        const productList = document.querySelector('.product-list--collection');
        let section = productList ? productList.closest('[data-section-id]') : null;
        if (!section) section = document.querySelector('[data-section-type="collection"]');
        return section ? section.getAttribute('data-section-id') : 'main-collection';
    }

    appendProducts(tempDiv) {
        let newSection = tempDiv.querySelector('[data-section-type="collection"]');
        if (!newSection) newSection = tempDiv.querySelector('[data-section-id]');
        if (!newSection) newSection = tempDiv;

        let newItems = [];
        const wrapper = newSection.querySelector('.js-product-list-wrapper');
        if (wrapper) {
            newItems = wrapper.querySelectorAll('.js-pagination-result');
        }
        
        if (newItems.length === 0) {
            const list = newSection.querySelector('.product-list--collection');
            if (list) {
                newItems = list.querySelectorAll('.js-pagination-result');
                if (newItems.length === 0) {
                    newItems = list.querySelectorAll('.product-item');
                }
            }
        }
        
        this.productList = document.querySelector('.product-list--collection');
        
        if (newItems.length > 0 && this.productList) {
            newItems.forEach(item => {
                if (item.classList.contains('js-pagination-result')) {
                    this.productList.appendChild(item.cloneNode(true));
                } else {
                    const wrapper = document.createElement('div');
                    wrapper.className = 'js-pagination-result';
                    wrapper.appendChild(item.cloneNode(true));
                    this.productList.appendChild(wrapper);
                }
            });
        }
    }

    updatePagination(tempDiv, isRestoring) {
        const newPagination = tempDiv.querySelector('.js-pagination');
        this.paginationElement = document.querySelector('.js-pagination');
        this.loadMoreButton = document.querySelector('.js-pagination-load-more');

        if (newPagination && this.paginationElement) {
            const newButton = newPagination.querySelector('.js-pagination-load-more');
            if (newButton && this.loadMoreButton) {
                const nextUrl = newButton.getAttribute('data-next-url');
                if (nextUrl) {
                    this.loadMoreButton.setAttribute('data-next-url', nextUrl);
                    this.loadMoreButton.style.display = '';
                    
                    const currentPage = newPagination.getAttribute('data-current-page');
                    if (currentPage) {
                        this.paginationElement.setAttribute('data-current-page', currentPage);
                    }
                } else {
                    this.loadMoreButton.style.display = 'none';
                }
            } else if (this.loadMoreButton) {
                this.loadMoreButton.style.display = 'none';
            }
        }
    }

    setLoadingState(loading, isRestoring) {
        this.loadMoreButton = document.querySelector('.js-pagination-load-more');
        if (!this.loadMoreButton) return;
        
        if (loading) {
            if (!this.loadMoreButton.dataset.originalText) {
                this.loadMoreButton.dataset.originalText = this.loadMoreButton.textContent;
            }
            this.loadMoreButton.classList.add('is-loading');
            this.loadMoreButton.disabled = true;
            this.loadMoreButton.textContent = isRestoring ? 'Restoring...' : 'Loading...';
        } else {
            this.loadMoreButton.classList.remove('is-loading');
            this.loadMoreButton.disabled = false;
            if (this.loadMoreButton.dataset.originalText) {
                this.loadMoreButton.textContent = this.loadMoreButton.dataset.originalText;
            }
        }
    }

    showError() {
        this.loadMoreButton = document.querySelector('.js-pagination-load-more');
        if (this.loadMoreButton) {
            const originalText = this.loadMoreButton.dataset.originalText || 'Load more';
            this.loadMoreButton.textContent = 'Error. Try again.';
            setTimeout(() => {
                this.loadMoreButton.textContent = originalText;
            }, 3000);
        }
    }

    saveUrlToState(url) {
        try {
            let urls = JSON.parse(sessionStorage.getItem(this.storageKey) || '[]');
            if (!urls.includes(url)) {
                urls.push(url);
                sessionStorage.setItem(this.storageKey, JSON.stringify(urls));
            }
        } catch (e) { /* console.warn(e); */ }
    }

    async restoreState() {
        try {
            const urls = JSON.parse(sessionStorage.getItem(this.storageKey) || '[]');
            if (urls.length === 0) return;

            const currentUrl = window.location.href;
            const currentSearch = window.location.search;

            for (const url of urls) {
                if (url.includes(currentSearch) && currentSearch.includes('page=')) {
                    continue;
                }
                await this.loadMore(url, true);
            }
        } catch (e) {
            // console.error('Restore failed', e);
            sessionStorage.removeItem(this.storageKey);
        }
    }
  }

  let paginationInstance = null;

  function init() {
    if (!paginationInstance) {
        paginationInstance = new ImprovedLoadMorePagination();
    } else {
        paginationInstance.init();
    }
    window.t25LoadMorePagination = paginationInstance;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('theme:section:load', (e) => {
    if (e.detail?.sectionId?.includes('collection')) {
      setTimeout(init, 100);
    }
  });
  
  document.addEventListener('theme:loading:end', () => {
      setTimeout(init, 100);
  });

})();
